import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line
import classNames from "classnames";

class Label extends React.Component {
  render() {
    const {
      mutted,
      strong,
      slim,
      size,
      margin,
      text,
      upper,
      lower,
      theme,
      className,
      style,
      children,
      ...extraProps
    } = this.props;

    const paragraphClasses = classNames(
      "label",
      {
        mutted: mutted,
        strong: strong,
        slim: slim,
        [size]: size,
        [`margin-${margin}`]: margin,
        [`text-${text}`]: text,
        "text-upper": upper,
        "text-lower": lower,
        [`label-${theme}`]: theme
      },
      className
    );

    return React.createElement(
      "p",
      {
        className: paragraphClasses,
        style,
        ...(extraProps || {})
      },
      children
    );
  }
}

Label.defaultProps = {
  size: null,
  margin: false,
  mutted: false,
  strong: false,
  slim: false,
  text: false,
  upper: false,
  lower: false,
  theme: null,
  className: "",
  style: {},
  children: null
};

Label.propTypes = {
  size: PropTypes.oneOf(["small", "x-small"]),
  margin: PropTypes.oneOf([false, "no", "no-top", "no-bottom"]),
  mutted: PropTypes.bool,
  strong: PropTypes.bool,
  slim: PropTypes.bool,
  text: PropTypes.oneOf([false, "left", "center", "right"]),
  upper: PropTypes.bool,
  lower: PropTypes.bool,
  theme: PropTypes.oneOf([
    "default",
    "primary",
    "dark",
    "grey",
    "error",
    "warning",
    "warning-active",
    "success",
    "success-active"
  ]),
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType(PropTypes.string, PropTypes.number)
  ),
  children: PropTypes.node
};

export default Label;
